// extracted by mini-css-extract-plugin
export default {"mainButtonsContainer":"invoices_mainButtonsContainer__BpKLt"};